import React from "react";
import { Breadcrumb } from "../../components/ui";
import { useParams } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import { InstitutionalCommunicationForm } from "../../components/Forms/InstitutionalCommunicationForm";
import { useGetInstitutionalCommunicationByIdQuery } from "../../store/services/institutional-communications";

export const EditInstitutionalCommunication = () => {
  const { communicationId } = useParams();

  const { data: communicationData, isLoading } =
    useGetInstitutionalCommunicationByIdQuery(communicationId || "");

  return (
    <>
      <Breadcrumb items={[{ label: "Comunicaciones", to: "/institutional-communications" }, { label: "Editar" }]} />
    <div className="p-card gap-4 p-3">
      <h1 className="text-center text-3xl">Editar comunicación institucional</h1>
      {isLoading ? (
        <div className="gap-4 flex flex-column justify-content-center align-items-center p-3 min-h-11rem p-8">
          <h1 className="text-center text-3xl font-bold mb-6">Cargando contenido</h1>
          <ProgressSpinner />
        </div>
      ) : (
        <InstitutionalCommunicationForm communicationData={communicationData} />
      )}
    </div>
    </>
  );
};
